import React, { useRef, useState } from 'react';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import 'rc-dropdown/assets/index.css';
import useElementSize from '../../hooks/useElementSize';

function DropdownSelect({
  alias,
  required,
  inputValues,
  handleChange,
  defaultValue,
  errMsg,
  preValues,
  hiddenField,
}) {
  const [ref, width] = useElementSize();
  const options = Object.values(preValues);
  const selected = inputValues[hiddenField.alias].value;
  const menuRef = useRef(null);

  const [haveBeenOpen, setHaveBeenOpen] = useState(false);
  const labelValue = required ? `${defaultValue}*` : defaultValue;
  const errMsgStyles = required && haveBeenOpen && !selected ? 'inline' : 'hidden';
  const labelStyles = selected
    ? 'top-0 -translate-y-full -translate-x-[10%] scale-75 left-0'
    : 'top-1/2 -translate-y-1/2 left-4';

  const handleSelect = (value, index) => {
    // console.log(value);
    const values = [
      {
        name: alias,
        value,
        required: false,
      },
      {
        name: hiddenField.alias,
        value,
        required: false,
      },
    ];

    handleChange(values, null, true);
  };

  const handleOpen = (open) => {
    if (open) {
      setHaveBeenOpen(true);
    }
  };

  const menu = (
    <Menu
      className="bg-white border !shadow-2xl rounded-sm !max-h-[16rem] overflow-y-auto"
      style={{ width: `${width}px` }}
    >
      {options.map((item, index) => (
        <MenuItem
          key={index}
          onClick={() => {
            handleSelect(item === defaultValue ? '' : item, index);
          }}
          className={`text-primary transition-all duration-100 select-none !w-full text-left
          !p-2 !hover:bg-pale-grey outline-none text-base
          ${item === selected ? 'bg-pale-grey text-darkGrey' : 'bg-white'}`}
        >
          {item}
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <div ref={ref} className="w-full relative">
      <Dropdown
        ref={menuRef}
        trigger={['click']}
        overlay={menu}
        onVisibleChange={handleOpen}
        animation="slide-up"
      >
        <button
          type="button"
          className="w-full h-[44px] flex justify-between items-center border
          border-greyCloud transition-all duration-100"
        >
          <label
            htmlFor={alias}
            className={`absolute transition-all duration-300 text-darkGrey ${labelStyles}`}
          >
            {labelValue}
          </label>
          <span className="text-darkGrey text-base px-4 truncate">{selected}</span>
          {errMsg && (
            <span className={`text-xs text-red absolute -bottom-5 left-0 ${errMsgStyles}`}>
              {errMsg}
            </span>
          )}
          <i className="h-1.5 w-1.5 border-b-[1.5px] border-r-[1.5px] border-red rotate-45 mr-4" />
        </button>
      </Dropdown>
    </div>
  );
}

export default DropdownSelect;
